import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
var font = variables.font,
  global = variables.global;
export var notFound = /*#__PURE__*/css("padding:20px;font-weight:", font.h4FontWeight, ";text-align:center;");
export var breadcrumbs = /*#__PURE__*/css("margin:0 auto;padding:10px 0 10px 16px;", media('>=tablet'), "{max-width:100%;}", media('>=desktop'), "{max-width:", global.desktopMinWidth, ";padding-top:21px;padding-bottom:18px;padding-left:3px;}");
export var wrapper = {
  name: "1y002rz",
  styles: ".button__icon{display:inline-block;}"
};